var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_29_1",
    "data-name": "Component 29 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 36.5,
    viewBox: "0 0 30 18.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen-to-square-solid_1_",
    className: "PenToSquareSolid1",
    "data-name": "pen-to-square-solid (1)",
    d: "M16.753,5.858a1.987,1.987,0,0,0-2.813,0L12.87,6.924,16.348,10.4l1.069-1.069a1.987,1.987,0,0,0,0-2.813ZM6.124,13.674a1.963,1.963,0,0,0-.48.778L4.593,17.606a.857.857,0,0,0,.206.874.846.846,0,0,0,.874.206l3.154-1.051a2.057,2.057,0,0,0,.778-.48l5.943-5.947L12.067,7.727Z",
    transform: "translate(1 -5.275)",
    fill: "#24b8c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pen-to-square-solid_1_2",
    className: "PenToSquareSolid2",
    "data-name": "pen-to-square-solid (1)",
    d: "M3.41,7.361A3.411,3.411,0,0,0,0,10.771v9.094a3.411,3.411,0,0,0,3.41,3.41H12.5a3.411,3.411,0,0,0,3.41-3.41v-3.41a1.137,1.137,0,0,0-2.273,0v3.41A1.136,1.136,0,0,1,12.5,21H3.41a1.136,1.136,0,0,1-1.137-1.137V10.771A1.136,1.136,0,0,1,3.41,9.635H6.82a1.137,1.137,0,1,0,0-2.273Z",
    transform: "translate(0 -4.318)",
    fill: "#24b8c0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.b807e6189b6dd9128b69ee865dd87743.svg";
export { ForwardRef as ReactComponent };